// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-drawer.p-drawer-right {
  width: 25rem !important;
  background-color: var(--fourth-bg) !important;
  color: black;
}

/* Round dialog and subtle shadow */
::ng-deep .login-dialog .p-dialog {
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
}
::ng-deep .login-dialog .p-dialog .input-group input {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  font-size: small;
}
::ng-deep .login-dialog .p-dialog .form-control:focus {
  outline: none;
  box-shadow: none;
}

.pointer {
  cursor: pointer;
}

.cart-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #fe5326;
  color: white;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.footer-bottom-checkout {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 20px 0 20px;
  background-color: var(--fourth-bg);
  min-height: 350px;
}

.cart-body {
  height: calc(100% - 350px);
  padding-bottom: 10px;
  overflow: auto;
}

::-webkit-scrollbar {
  display: none;
}

/* Quantity button style - smaller and circular */
/* Promo input styling */
.input-group input {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid #dddddd;
  padding: 10px;
  font-size: 15px;
}

/* Checkout Button */
::ng-deep .checkout-btn {
  background: linear-gradient(to left, var(--gradient1) 50%, var(--gradient2) 50%) right/200% 100% !important;
  color: white;
  font-weight: bold;
  border: none !important;
}
::ng-deep .checkout-btn:hover {
  background: linear-gradient(to left, var(--gradient2) 100%, var(--gradient1) 100%) left !important;
  border: none !important;
}

.offer-section {
  max-width: 400px;
  margin: auto;
}

.offer-block img, .offer-img {
  width: 100%;
  border-radius: 7px;
  transition: transform 0.4s ease;
}

/* Hover animation */
.offer-block img:hover, .offer-img:hover {
  transform: scale(1.1);
}

/* Fade-in animation */
.fade-in {
  opacity: 0;
  transform: translateY(25px);
  animation: fadeIn 0.6s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-offer-card {
  background-color: #f9f9f9;
  border: 1px solid #eee;
}

.offer-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

/* Primary text and borders */
.text-primary {
  color: #0f79b0 !important;
}

/* Copy icon click animation */
.copy-icon:active {
  transform: scale(1.5);
  color: #0f79b0;
  transition: transform 0.2s, color 0.2s;
}

/********************************************responsive start*******************************************************************************************/
@media screen and (max-width: 1199px) {
  .cart-body {
    padding-bottom: 50px;
    height: calc(100% - 300px);
  }
}
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
  color: #888; /* Light gray text */
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ccc; /* Light gray line */
}

.divider:not(:empty)::before {
  margin-right: 0.75em;
}

.divider:not(:empty)::after {
  margin-left: 0.75em;
}

.offer-carousel-box {
  background: var(--white);
  border-radius: 15px;
}

.popup-wrapper {
  position: fixed;
  bottom: -100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050;
  transition: bottom 0.6s ease;
  width: 100%;
  max-width: 400px;
}
.popup-wrapper.show {
  bottom: 15px;
}
.popup-wrapper .popup-content {
  background-color: var(--fourth-bg);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding: 15px;
}
.popup-wrapper .popup-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
.popup-wrapper.offer-popup .popup-content .owl-carousel .owl-nav {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.scss"],"names":[],"mappings":"AACA;EACI,uBAAA;EACA,6CAAA;EACA,YAAA;AAAJ;;AAGA,mCAAA;AACA;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;AAAJ;AAEQ;EACI,2BAAA;EACA,8BAAA;EAEA,gBAAA;AADZ;AAKQ;EACI,aAAA;EACA,gBAAA;AAHZ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;AANJ;;AASA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EAEA,iBAAA;AAPJ;;AAUA;EAEI,0BAAA;EACA,oBAAA;EACA,cAAA;AARJ;;AAWA;EACI,aAAA;AARJ;;AAWA,iDAAA;AAEA,wBAAA;AACA;EACI,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;AATJ;;AAYA,oBAAA;AACA;EACI,2GAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AATJ;AAUI;EACI,kGAAA;EACA,uBAAA;AARR;;AAYA;EACI,gBAAA;EACA,YAAA;AATJ;;AAYA;EAEI,WAAA;EAEA,kBAAA;EACA,+BAAA;AAXJ;;AAcA,oBAAA;AACA;EACI,qBAAA;AAXJ;;AAcA,sBAAA;AACA;EACI,UAAA;EACA,2BAAA;EACA,oCAAA;AAXJ;;AAcA;EACI;IACI,UAAA;IACA,wBAAA;EAXN;AACF;AAcA;EACI,yBAAA;EACA,sBAAA;AAZJ;;AAeA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;AAZJ;;AAeA,6BAAA;AACA;EACI,yBAAA;AAZJ;;AAiBA,8BAAA;AACA;EACI,qBAAA;EACA,cAAA;EACA,sCAAA;AAdJ;;AAkBA,wJAAA;AAEA;EACI;IACI,oBAAA;IAEA,0BAAA;EAjBN;AACF;AAqBA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA,EAAA,oBAAA;AAnBJ;;AAsBA;;EAEI,WAAA;EACA,OAAA;EACA,6BAAA,EAAA,oBAAA;AAnBJ;;AAsBA;EACI,oBAAA;AAnBJ;;AAsBA;EACI,mBAAA;AAnBJ;;AA4BA;EACI,wBAAA;EACA,mBAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;AAzBJ;AA0BI;EACI,YAAA;AAxBR;AA0BI;EACI,kCAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;AAxBR;AA0BI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAxBR;AA6BgB;EACI,wBAAA;AA3BpB","sourcesContent":["\n::ng-deep .p-drawer.p-drawer-right {\n    width: 25rem !important;\n    background-color: var(--fourth-bg) !important;\n    color: black;\n}\n\n/* Round dialog and subtle shadow */\n::ng-deep .login-dialog .p-dialog {\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #ffffff;\n    & .input-group {\n        & input {\n            border-top-left-radius: 5px;\n            border-bottom-left-radius: 5px;\n            //border: 1px solid #1397D5;\n            font-size: small;\n        }\n    }\n    & .form-control {\n        &:focus {\n            outline: none;\n            box-shadow: none;\n        }\n    }\n}\n\n\n.pointer {\n    cursor: pointer;\n}\n\n.cart-badge {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    background-color: #fe5326;\n    color: white;\n    border-radius: 50%;\n    width: 22px;\n    height: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: bold;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.footer-bottom-checkout {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 0 20px 0 20px;\n    background-color: var(--fourth-bg);\n    //padding-right: 40px;\n    min-height: 350px;\n}\n\n.cart-body {\n    //height: 65%;\n    height: calc(100% - 350px);\n    padding-bottom: 10px;\n    overflow: auto;\n}\n\n::-webkit-scrollbar {\n    display: none;\n}\n\n/* Quantity button style - smaller and circular */\n\n/* Promo input styling */\n.input-group input {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n    border: 1px solid #dddddd;\n    padding: 10px;\n    font-size: 15px;\n}\n\n/* Checkout Button */\n::ng-deep .checkout-btn {\n    background: linear-gradient(to left, var(--gradient1) 50%, var(--gradient2) 50%) right / 200% 100% !important;\n    color: white;\n    font-weight: bold;\n    border: none !important;\n    &:hover {\n        background: linear-gradient(to left, var(--gradient2) 100%, var(--gradient1) 100%) left !important;\n        border: none !important;\n    }\n}\n\n.offer-section {\n    max-width: 400px;\n    margin: auto;\n}\n\n.offer-block img, .offer-img {\n    //object-fit: cover;\n    width: 100%;\n    //max-height: 180px;\n    border-radius: 7px;\n    transition: transform 0.4s ease;\n}\n\n/* Hover animation */\n.offer-block img:hover, .offer-img:hover {\n    transform: scale(1.1);\n}\n\n/* Fade-in animation */\n.fade-in {\n    opacity: 0;\n    transform: translateY(25px);\n    animation: fadeIn 0.6s ease forwards;\n}\n\n@keyframes fadeIn {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.case-offer-card {\n    background-color: #f9f9f9;\n    border: 1px solid #eee;\n}\n\n.offer-img {\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n}\n\n/* Primary text and borders */\n.text-primary {\n    color: #0f79b0 !important;\n}\n\n\n\n/* Copy icon click animation */\n.copy-icon:active {\n    transform: scale(1.5);\n    color: #0f79b0;\n    transition: transform 0.2s, color 0.2s;\n}\n\n\n/********************************************responsive start*******************************************************************************************/\n\n@media screen and (max-width: 1199px) {\n    .cart-body {\n        padding-bottom: 50px;\n        //height: 57%;\n        height: calc(100% - 300px);\n    }\n}\n\n\n.divider {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 20px 0;\n    color: #888; /* Light gray text */\n}\n\n.divider::before,\n.divider::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid #ccc; /* Light gray line */\n}\n\n.divider:not(:empty)::before {\n    margin-right: .75em;\n}\n\n.divider:not(:empty)::after {\n    margin-left: .75em;\n\n}\n//#paypal-button-container {\n//    width: 100%;\n//    min-height: 45px;\n//    display: block;\n//}\n\n.offer-carousel-box {\n    background: var(--white);\n    border-radius: 15px;\n}\n\n.popup-wrapper {\n    position: fixed;\n    bottom: -100%;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1050;\n    transition: bottom 0.6s ease;\n    width: 100%;\n    max-width: 400px;\n    &.show {\n        bottom: 15px;\n    }\n    & .popup-content {\n        background-color: var(--fourth-bg);\n        border-radius: 16px;\n        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n        overflow: hidden;\n        padding: 15px;\n    }\n    & .popup-image {\n        width: 100%;\n        height: auto;\n        display: block;\n        object-fit: cover;\n    }\n    &.offer-popup {\n        & .popup-content {\n            & .owl-carousel {\n                & .owl-nav {\n                    display: none !important;\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
